export default {"id":"58a95761","attrs":{"viewBox":"0 0 512 512","width":"512","height":"512"}}